/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { ReceiptModal } from './styles';
import { toast } from 'react-toastify';
import { useQuitacao } from '~/pages/QuitacaoEmLote/QuitacaoContext';
import { jsPDF } from 'jspdf';
import { AiOutlinePrinter } from 'react-icons/ai';
import { GoDownload } from 'react-icons/go';
import { RiCloseLine } from 'react-icons/ri';

export const FormActions: React.FC = () => {
  const { showModalRecibo, setShowModalRecibo, recibo } = useQuitacao();

  const gerarEbaixarPDF = (receipt?: string, imprimir = false) => {
    const receiptInText = receipt || recibo;
    const linhas = receiptInText.split('\n');
    const numeroDeLinhas = linhas.length;

    const espacamentoEntreLinhas = 5; // Ajuste este valor conforme necessário
    const alturaPagina = numeroDeLinhas * espacamentoEntreLinhas + 20; // + 20mm de margem
    const larguraPagina = 80;

    // eslint-disable-next-line new-cap
    const doc = new jsPDF({
      orientation: 'p',
      unit: 'mm',
      // format: [4 * 25.4, 6 * 25.4], // Aproximadamente 4x6 polegadas
      format: [larguraPagina, alturaPagina],
    });

    doc.setFont('Courier'); // Define a fonte para Courier
    doc.setFontSize(8); // Define o tamanho da fonte
    doc.setTextColor(0, 0, 0); // Define a cor do texto para preto

    linhas.forEach((linha, index) => {
      doc.text(linha, 0, 10 + index * espacamentoEntreLinhas);
    });

    if (imprimir) {
      // Obtém o conteúdo do PDF como uma string
      const pdfContent = doc.output();

      // Abre o conteúdo do PDF em uma nova janela ou guia
      const newWindow = window.open('', '_blank');
      if (newWindow) {
        newWindow.document.write(
          '<html><head><title>Recibo</title></head><body style="margin: 0; padding: 0;">',
        );
        newWindow.document.write(
          `<embed width="100%" height="100%" name="plugin" src="data:application/pdf;base64,${btoa(
            pdfContent,
          )}" type="application/pdf">`,
        );
        newWindow.document.write('</body></html>');
      } else {
        toast.error('Não foi possível abrir o recibo para impressão.');
      }
      return;
    }
    doc.save('recibo.pdf');
  };

  return (
    <>
      <ReceiptModal
        show={showModalRecibo}
        onHide={() => {
          setShowModalRecibo(false);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="lg"
        // backdrop={!loading || 'static'}
      >
        <Modal.Header>
          <Modal.Title>Visualização do Recibo</Modal.Title>
          <Button
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              background: 'transparent',
              border: 'none',
              padding: '0px',
            }}
            onClick={() => {
              setShowModalRecibo(false);
            }}
          >
            <RiCloseLine size={23} style={{ color: '#57069e' }} />
          </Button>
        </Modal.Header>
        <Modal.Body>
          <div
            className="receipt"
            style={{
              whiteSpace: 'pre-wrap',
              fontFamily: 'Courier New, monospace',
              fontSize: '12px',
              lineHeight: '1.6',
              letterSpacing: '0px',
              marginTop: '20px',
              marginBottom: '20px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'black',
            }}
          >
            <div
              style={{
                border: '1px solid grey',
                paddingLeft: '35px',
                paddingTop: '20px',
                paddingBottom: '40px',
                paddingRight: '5px',
              }}
            >
              {recibo}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              gerarEbaixarPDF(recibo, true);
            }}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '3px',
            }}
          >
            Imprimir
            <AiOutlinePrinter size={24} className="btn-icon" />
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              gerarEbaixarPDF(recibo);
            }}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '3px',
            }}
          >
            Baixar
            <GoDownload size={24} className="btn-icon" />
          </Button>
        </Modal.Footer>
      </ReceiptModal>
    </>
  );
};
